// «Ver en el mapa» desde una notificación: selecciona la unidad como si se
// tocara en la lista (la sigue en el mapa y despliega su tarjeta). Quién está
// desplegada es estado de VehicleList, así que se le avisa con un evento; si la
// lista todavía no existe (la campana del header está en todas las apps y hay
// que navegar al mapa primero), la deja pendiente y la lista la toma al montar.
export const REVEAL_UNIT_EVENT = "dumax:reveal-unit";

// Caduca en vez de consumirse: la lista se monta dos veces (panel de
// escritorio y hoja del celular) y las dos deben tomarla; 5 s cubren la
// navegación al mapa y, pasado eso, volver al mapa no re-selecciona.
const TTL_MS = 5000;
let pending: { id: string; at: number } | null = null;

export const revealUnit = (deviceId: string) => {
  pending = { id: deviceId, at: Date.now() };
  window.dispatchEvent(new CustomEvent<string>(REVEAL_UNIT_EVENT, { detail: deviceId }));
};

export const pendingReveal = (now = Date.now()) => (pending && now - pending.at < TTL_MS ? pending.id : null);
